/** 内置词典数据 — CET-4/6 高频词 */
export const DICT_DATA = [
  { word: "ability", phonetic: "/əˈbɪləti/", pos: "n.", definitions: ["能力", "才能"] },
  { word: "able", phonetic: "/ˈeɪbl/", pos: "adj.", definitions: ["能够的", "有能力的"] },
  { word: "about", phonetic: "/əˈbaʊt/", pos: "prep.", definitions: ["关于", "大约"] },
  { word: "above", phonetic: "/əˈbʌv/", pos: "prep.", definitions: ["在...之上", "超过"] },
  { word: "accept", phonetic: "/əkˈsept/", pos: "v.", definitions: ["接受", "同意"] },
  { word: "access", phonetic: "/ˈækses/", pos: "n.", definitions: ["入口", "访问"] },
  { word: "accident", phonetic: "/ˈæksɪdənt/", pos: "n.", definitions: ["事故", "意外"] },
  { word: "account", phonetic: "/əˈkaʊnt/", pos: "n.", definitions: ["账户", "解释"] },
  { word: "achieve", phonetic: "/əˈtʃiːv/", pos: "v.", definitions: ["实现", "达到"] },
  { word: "across", phonetic: "/əˈkrɒs/", pos: "prep.", definitions: ["穿过"] },
  { word: "action", phonetic: "/ˈækʃn/", pos: "n.", definitions: ["行动"] },
  { word: "active", phonetic: "/ˈæktɪv/", pos: "adj.", definitions: ["积极的"] },
  { word: "activity", phonetic: "/ækˈtɪvəti/", pos: "n.", definitions: ["活动"] },
  { word: "actual", phonetic: "/ˈæktʃuəl/", pos: "adj.", definitions: ["实际的"] },
  { word: "add", phonetic: "/æd/", pos: "v.", definitions: ["增加"] },
  { word: "address", phonetic: "/əˈdres/", pos: "n.", definitions: ["地址"] },
  { word: "adjust", phonetic: "/əˈdʒʌst/", pos: "v.", definitions: ["调整"] },
  { word: "admit", phonetic: "/ədˈmɪt/", pos: "v.", definitions: ["承认"] },
  { word: "adopt", phonetic: "/əˈdɒpt/", pos: "v.", definitions: ["采用", "收养"] },
  { word: "adult", phonetic: "/ˈædʌlt/", pos: "n.", definitions: ["成年人"] },
  { word: "advance", phonetic: "/ədˈvɑːns/", pos: "v.", definitions: ["前进"] },
  { word: "advantage", phonetic: "/ədˈvɑːntɪdʒ/", pos: "n.", definitions: ["优势"] },
  { word: "advice", phonetic: "/ədˈvaɪs/", pos: "n.", definitions: ["建议"] },
  { word: "affect", phonetic: "/əˈfekt/", pos: "v.", definitions: ["影响"] },
  { word: "afford", phonetic: "/əˈfɔːd/", pos: "v.", definitions: ["买得起"] },
  { word: "afraid", phonetic: "/əˈfreɪd/", pos: "adj.", definitions: ["害怕的"] },
  { word: "after", phonetic: "/ˈɑːftə/", pos: "prep.", definitions: ["在...之后"] },
  { word: "against", phonetic: "/əˈɡenst/", pos: "prep.", definitions: ["反对"] },
  { word: "age", phonetic: "/eɪdʒ/", pos: "n.", definitions: ["年龄"] },
  { word: "agency", phonetic: "/ˈeɪdʒənsi/", pos: "n.", definitions: ["机构"] },
  { word: "ago", phonetic: "/əˈɡəʊ/", pos: "adv.", definitions: ["以前"] },
  { word: "agree", phonetic: "/əˈɡriː/", pos: "v.", definitions: ["同意"] },
  { word: "ahead", phonetic: "/əˈhed/", pos: "adv.", definitions: ["在前面"] },
  { word: "aim", phonetic: "/eɪm/", pos: "n.", definitions: ["目标"] },
  { word: "air", phonetic: "/eə/", pos: "n.", definitions: ["空气"] },
  { word: "airport", phonetic: "/ˈeəpɔːt/", pos: "n.", definitions: ["机场"] },
  { word: "all", phonetic: "/ɔːl/", pos: "adj.", definitions: ["全部的"] },
  { word: "allow", phonetic: "/əˈlaʊ/", pos: "v.", definitions: ["允许"] },
  { word: "almost", phonetic: "/ˈɔːlməʊst/", pos: "adv.", definitions: ["几乎"] },
  { word: "alone", phonetic: "/əˈləʊn/", pos: "adj.", definitions: ["单独的"] },
  { word: "along", phonetic: "/əˈlɒŋ/", pos: "prep.", definitions: ["沿着"] },
  { word: "already", phonetic: "/ɔːlˈredi/", pos: "adv.", definitions: ["已经"] },
  { word: "also", phonetic: "/ˈɔːlsəʊ/", pos: "adv.", definitions: ["也"] },
  { word: "although", phonetic: "/ɔːlˈðəʊ/", pos: "conj.", definitions: ["虽然"] },
  { word: "always", phonetic: "/ˈɔːlweɪz/", pos: "adv.", definitions: ["总是"] },
  { word: "among", phonetic: "/əˈmʌŋ/", pos: "prep.", definitions: ["在...之中"] },
  { word: "amount", phonetic: "/əˈmaʊnt/", pos: "n.", definitions: ["数量"] },
  { word: "analyze", phonetic: "/ˈænəlaɪz/", pos: "v.", definitions: ["分析"] },
  { word: "ancient", phonetic: "/ˈeɪnʃənt/", pos: "adj.", definitions: ["古代的"] },
  { word: "anger", phonetic: "/ˈæŋɡə/", pos: "n.", definitions: ["愤怒"] },
  { word: "angle", phonetic: "/ˈæŋɡl/", pos: "n.", definitions: ["角度"] },
  { word: "angry", phonetic: "/ˈæŋɡri/", pos: "adj.", definitions: ["生气的"] },
  { word: "animal", phonetic: "/ˈænɪml/", pos: "n.", definitions: ["动物"] },
  { word: "another", phonetic: "/əˈnʌðə/", pos: "adj.", definitions: ["另一个"] },
  { word: "answer", phonetic: "/ˈɑːnsə/", pos: "n.", definitions: ["回答"] },
  { word: "anxiety", phonetic: "/æŋˈzaɪəti/", pos: "n.", definitions: ["焦虑"] },
  { word: "any", phonetic: "/ˈeni/", pos: "adj.", definitions: ["任何的"] },
  { word: "apart", phonetic: "/əˈpɑːt/", pos: "adv.", definitions: ["分开"] },
  { word: "appear", phonetic: "/əˈpɪə/", pos: "v.", definitions: ["出现"] },
  { word: "apply", phonetic: "/əˈplaɪ/", pos: "v.", definitions: ["申请"] },
  { word: "approach", phonetic: "/əˈprəʊtʃ/", pos: "v.", definitions: ["接近"] },
  { word: "appropriate", phonetic: "/əˈprəʊpriət/", pos: "adj.", definitions: ["适当的"] },
  { word: "approve", phonetic: "/əˈpruːv/", pos: "v.", definitions: ["批准"] },
  { word: "area", phonetic: "/ˈeəriə/", pos: "n.", definitions: ["区域"] },
  { word: "argue", phonetic: "/ˈɑːɡjuː/", pos: "v.", definitions: ["争论"] },
  { word: "arm", phonetic: "/ɑːm/", pos: "n.", definitions: ["手臂"] },
  { word: "army", phonetic: "/ˈɑːmi/", pos: "n.", definitions: ["军队"] },
  { word: "around", phonetic: "/əˈraʊnd/", pos: "prep.", definitions: ["围绕"] },
  { word: "arrange", phonetic: "/əˈreɪndʒ/", pos: "v.", definitions: ["安排"] },
  { word: "arrive", phonetic: "/əˈraɪv/", pos: "v.", definitions: ["到达"] },
  { word: "art", phonetic: "/ɑːt/", pos: "n.", definitions: ["艺术"] },
  { word: "article", phonetic: "/ˈɑːtɪkl/", pos: "n.", definitions: ["文章"] },
  { word: "ask", phonetic: "/ɑːsk/", pos: "v.", definitions: ["询问"] },
  { word: "aspect", phonetic: "/ˈæspekt/", pos: "n.", definitions: ["方面"] },
  { word: "assess", phonetic: "/əˈses/", pos: "v.", definitions: ["评估"] },
  { word: "assign", phonetic: "/əˈsaɪn/", pos: "v.", definitions: ["分配"] },
  { word: "assist", phonetic: "/əˈsɪst/", pos: "v.", definitions: ["协助"] },
  { word: "assume", phonetic: "/əˈsjuːm/", pos: "v.", definitions: ["假设"] },
  { word: "attach", phonetic: "/əˈtætʃ/", pos: "v.", definitions: ["附上"] },
  { word: "attack", phonetic: "/əˈtæk/", pos: "v.", definitions: ["攻击"] },
  { word: "attempt", phonetic: "/əˈtempt/", pos: "v.", definitions: ["尝试"] },
  { word: "attend", phonetic: "/əˈtend/", pos: "v.", definitions: ["出席"] },
  { word: "attention", phonetic: "/əˈtenʃn/", pos: "n.", definitions: ["注意", "注意力"] },
  { word: "attitude", phonetic: "/ˈætɪtjuːd/", pos: "n.", definitions: ["态度"] },
  { word: "attract", phonetic: "/əˈtrækt/", pos: "v.", definitions: ["吸引"] },
  { word: "audience", phonetic: "/ˈɔːdiəns/", pos: "n.", definitions: ["观众"] },
  { word: "author", phonetic: "/ˈɔːθə/", pos: "n.", definitions: ["作者"] },
  { word: "authority", phonetic: "/ɔːˈθɒrəti/", pos: "n.", definitions: ["权威"] },
  { word: "available", phonetic: "/əˈveɪləbl/", pos: "adj.", definitions: ["可用的"] },
  { word: "average", phonetic: "/ˈævərɪdʒ/", pos: "n.", definitions: ["平均"] },
  { word: "avoid", phonetic: "/əˈvɔɪd/", pos: "v.", definitions: ["避免"] },
  { word: "award", phonetic: "/əˈwɔːd/", pos: "n.", definitions: ["奖励"] },
  { word: "aware", phonetic: "/əˈweə/", pos: "adj.", definitions: ["意识到的"] },
  { word: "away", phonetic: "/əˈweɪ/", pos: "adv.", definitions: ["离开"] },
  { word: "baby", phonetic: "/ˈbeɪbi/", pos: "n.", definitions: ["婴儿"] },
  { word: "back", phonetic: "/bæk/", pos: "n.", definitions: ["背部"] },
  { word: "background", phonetic: "/ˈbækɡraʊnd/", pos: "n.", definitions: ["背景"] },
  { word: "bad", phonetic: "/bæd/", pos: "adj.", definitions: ["坏的"] },
  { word: "balance", phonetic: "/ˈbæləns/", pos: "n.", definitions: ["平衡"] },
  { word: "ball", phonetic: "/bɔːl/", pos: "n.", definitions: ["球"] },
  { word: "bank", phonetic: "/bæŋk/", pos: "n.", definitions: ["银行"] },
  { word: "base", phonetic: "/beɪs/", pos: "n.", definitions: ["基础"] },
  { word: "basic", phonetic: "/ˈbeɪsɪk/", pos: "adj.", definitions: ["基本的"] },
  { word: "battle", phonetic: "/ˈbætl/", pos: "n.", definitions: ["战斗"] },
  { word: "beach", phonetic: "/biːtʃ/", pos: "n.", definitions: ["海滩"] },
  { word: "bear", phonetic: "/beə/", pos: "v.", definitions: ["承受"] },
  { word: "beat", phonetic: "/biːt/", pos: "v.", definitions: ["打败"] },
  { word: "beautiful", phonetic: "/ˈbjuːtɪfl/", pos: "adj.", definitions: ["美丽的"] },
  { word: "because", phonetic: "/bɪˈkɒz/", pos: "conj.", definitions: ["因为"] },
  { word: "become", phonetic: "/bɪˈkʌm/", pos: "v.", definitions: ["变成"] },
  { word: "before", phonetic: "/bɪˈfɔː/", pos: "prep.", definitions: ["在...之前"] },
  { word: "begin", phonetic: "/bɪˈɡɪn/", pos: "v.", definitions: ["开始"] },
  { word: "behavior", phonetic: "/bɪˈheɪvjə/", pos: "n.", definitions: ["行为"] },
  { word: "behind", phonetic: "/bɪˈhaɪnd/", pos: "prep.", definitions: ["在...后面"] },
  { word: "believe", phonetic: "/bɪˈliːv/", pos: "v.", definitions: ["相信"] },
  { word: "belong", phonetic: "/bɪˈlɒŋ/", pos: "v.", definitions: ["属于"] },
  { word: "below", phonetic: "/bɪˈləʊ/", pos: "prep.", definitions: ["在...下面"] },
  { word: "benefit", phonetic: "/ˈbenɪfɪt/", pos: "n.", definitions: ["好处"] },
  { word: "best", phonetic: "/best/", pos: "adj.", definitions: ["最好的"] },
  { word: "better", phonetic: "/ˈbetə/", pos: "adj.", definitions: ["更好的"] },
  { word: "between", phonetic: "/bɪˈtwiːn/", pos: "prep.", definitions: ["在...之间"] },
  { word: "beyond", phonetic: "/bɪˈjɒnd/", pos: "prep.", definitions: ["超过"] },
  { word: "big", phonetic: "/bɪɡ/", pos: "adj.", definitions: ["大的"] },
  { word: "bill", phonetic: "/bɪl/", pos: "n.", definitions: ["账单"] },
  { word: "biology", phonetic: "/baɪˈɒlədʒi/", pos: "n.", definitions: ["生物学"] },
  { word: "bird", phonetic: "/bɜːd/", pos: "n.", definitions: ["鸟"] },
  { word: "birth", phonetic: "/bɜːθ/", pos: "n.", definitions: ["出生"] },
  { word: "bit", phonetic: "/bɪt/", pos: "n.", definitions: ["一点"] },
  { word: "black", phonetic: "/blæk/", pos: "adj.", definitions: ["黑色的"] },
  { word: "block", phonetic: "/blɒk/", pos: "n.", definitions: ["块", "阻塞"] },
  { word: "blood", phonetic: "/blʌd/", pos: "n.", definitions: ["血液"] },
  { word: "blue", phonetic: "/bluː/", pos: "adj.", definitions: ["蓝色的"] },
  { word: "board", phonetic: "/bɔːd/", pos: "n.", definitions: ["板"] },
  { word: "boat", phonetic: "/bəʊt/", pos: "n.", definitions: ["船"] },
  { word: "body", phonetic: "/ˈbɒdi/", pos: "n.", definitions: ["身体"] },
  { word: "bone", phonetic: "/bəʊn/", pos: "n.", definitions: ["骨头"] },
  { word: "book", phonetic: "/bʊk/", pos: "n.", definitions: ["书"] },
  { word: "border", phonetic: "/ˈbɔːdə/", pos: "n.", definitions: ["边界"] },
  { word: "born", phonetic: "/bɔːn/", pos: "v.", definitions: ["出生"] },
  { word: "borrow", phonetic: "/ˈbɒrəʊ/", pos: "v.", definitions: ["借"] },
  { word: "both", phonetic: "/bəʊθ/", pos: "adj.", definitions: ["两者的"] },
  { word: "bottom", phonetic: "/ˈbɒtəm/", pos: "n.", definitions: ["底部"] },
  { word: "box", phonetic: "/bɒks/", pos: "n.", definitions: ["盒子"] },
  { word: "boy", phonetic: "/bɔɪ/", pos: "n.", definitions: ["男孩"] },
  { word: "brain", phonetic: "/breɪn/", pos: "n.", definitions: ["大脑"] },
  { word: "branch", phonetic: "/brɑːntʃ/", pos: "n.", definitions: ["分支"] },
  { word: "brand", phonetic: "/brænd/", pos: "n.", definitions: ["品牌"] },
  { word: "brave", phonetic: "/breɪv/", pos: "adj.", definitions: ["勇敢的"] },
  { word: "bread", phonetic: "/bred/", pos: "n.", definitions: ["面包"] },
  { word: "break", phonetic: "/breɪk/", pos: "v.", definitions: ["打破"] },
  { word: "breath", phonetic: "/breθ/", pos: "n.", definitions: ["呼吸"] },
  { word: "bridge", phonetic: "/brɪdʒ/", pos: "n.", definitions: ["桥"] },
  { word: "brief", phonetic: "/briːf/", pos: "adj.", definitions: ["简短的"] },
  { word: "bright", phonetic: "/braɪt/", pos: "adj.", definitions: ["明亮的"] },
  { word: "bring", phonetic: "/brɪŋ/", pos: "v.", definitions: ["带来"] },
  { word: "broad", phonetic: "/brɔːd/", pos: "adj.", definitions: ["宽广的"] },
  { word: "broken", phonetic: "/ˈbrəʊkən/", pos: "adj.", definitions: ["破碎的"] },
  { word: "brother", phonetic: "/ˈbrʌðə/", pos: "n.", definitions: ["兄弟"] },
  { word: "brown", phonetic: "/braʊn/", pos: "adj.", definitions: ["棕色的"] },
  { word: "build", phonetic: "/bɪld/", pos: "v.", definitions: ["建造"] },
  { word: "building", phonetic: "/ˈbɪldɪŋ/", pos: "n.", definitions: ["建筑物"] },
  { word: "business", phonetic: "/ˈbɪznəs/", pos: "n.", definitions: ["商业"] },
  { word: "busy", phonetic: "/ˈbɪzi/", pos: "adj.", definitions: ["忙碌的"] },
  { word: "but", phonetic: "/bət/", pos: "conj.", definitions: ["但是"] },
  { word: "button", phonetic: "/ˈbʌtn/", pos: "n.", definitions: ["按钮"] },
  { word: "buy", phonetic: "/baɪ/", pos: "v.", definitions: ["购买"] },
  { word: "cake", phonetic: "/keɪk/", pos: "n.", definitions: ["蛋糕"] },
  { word: "call", phonetic: "/kɔːl/", pos: "v.", definitions: ["呼叫"] },
  { word: "calm", phonetic: "/kɑːm/", pos: "adj.", definitions: ["平静的"] },
  { word: "camera", phonetic: "/ˈkæmərə/", pos: "n.", definitions: ["相机"] },
  { word: "cancel", phonetic: "/ˈkænsl/", pos: "v.", definitions: ["取消"] },
  { word: "candidate", phonetic: "/ˈkændɪdət/", pos: "n.", definitions: ["候选人"] },
  { word: "capable", phonetic: "/ˈkeɪpəbl/", pos: "adj.", definitions: ["有能力的"] },
  { word: "capital", phonetic: "/ˈkæpɪtl/", pos: "n.", definitions: ["首都"] },
  { word: "capture", phonetic: "/ˈkæptʃə/", pos: "v.", definitions: ["捕获"] },
  { word: "car", phonetic: "/kɑː/", pos: "n.", definitions: ["汽车"] },
  { word: "card", phonetic: "/kɑːd/", pos: "n.", definitions: ["卡片"] },
  { word: "care", phonetic: "/keə/", pos: "n.", definitions: ["关心"] },
  { word: "career", phonetic: "/kəˈrɪə/", pos: "n.", definitions: ["职业"] },
  { word: "careful", phonetic: "/ˈkeəfl/", pos: "adj.", definitions: ["小心的"] },
  { word: "carry", phonetic: "/ˈkæri/", pos: "v.", definitions: ["携带"] },
  { word: "case", phonetic: "/keɪs/", pos: "n.", definitions: ["案例"] },
  { word: "cash", phonetic: "/kæʃ/", pos: "n.", definitions: ["现金"] },
  { word: "catch", phonetic: "/kætʃ/", pos: "v.", definitions: ["抓住"] },
  { word: "category", phonetic: "/ˈkætəɡəri/", pos: "n.", definitions: ["类别"] },
  { word: "cause", phonetic: "/kɔːz/", pos: "n.", definitions: ["原因"] },
  { word: "celebrate", phonetic: "/ˈselɪbreɪt/", pos: "v.", definitions: ["庆祝"] },
  { word: "center", phonetic: "/ˈsentə/", pos: "n.", definitions: ["中心"] },
  { word: "central", phonetic: "/ˈsentrəl/", pos: "adj.", definitions: ["中心的"] },
  { word: "century", phonetic: "/ˈsentʃəri/", pos: "n.", definitions: ["世纪"] },
  { word: "certain", phonetic: "/ˈsɜːtn/", pos: "adj.", definitions: ["确定的"] },
  { word: "chain", phonetic: "/tʃeɪn/", pos: "n.", definitions: ["链条"] },
  { word: "chair", phonetic: "/tʃeə/", pos: "n.", definitions: ["椅子"] },
  { word: "challenge", phonetic: "/ˈtʃælɪndʒ/", pos: "n.", definitions: ["挑战"] },
  { word: "chance", phonetic: "/tʃɑːns/", pos: "n.", definitions: ["机会"] },
  { word: "change", phonetic: "/tʃeɪndʒ/", pos: "v.", definitions: ["改变"] },
  { word: "channel", phonetic: "/ˈtʃænl/", pos: "n.", definitions: ["频道"] },
  { word: "chapter", phonetic: "/ˈtʃæptə/", pos: "n.", definitions: ["章节"] },
  { word: "character", phonetic: "/ˈkærəktə/", pos: "n.", definitions: ["角色"] },
  { word: "charge", phonetic: "/tʃɑːdʒ/", pos: "v.", definitions: ["收费"] },
  { word: "cheap", phonetic: "/tʃiːp/", pos: "adj.", definitions: ["便宜的"] },
  { word: "check", phonetic: "/tʃek/", pos: "v.", definitions: ["检查"] },
  { word: "child", phonetic: "/tʃaɪld/", pos: "n.", definitions: ["孩子"] },
  { word: "choice", phonetic: "/tʃɔɪs/", pos: "n.", definitions: ["选择"] },
  { word: "choose", phonetic: "/tʃuːz/", pos: "v.", definitions: ["选择"] },
  { word: "church", phonetic: "/tʃɜːtʃ/", pos: "n.", definitions: ["教堂"] },
  { word: "circle", phonetic: "/ˈsɜːkl/", pos: "n.", definitions: ["圆圈"] },
  { word: "city", phonetic: "/ˈsɪti/", pos: "n.", definitions: ["城市"] },
  { word: "civil", phonetic: "/ˈsɪvl/", pos: "adj.", definitions: ["公民的"] },
  { word: "claim", phonetic: "/kleɪm/", pos: "v.", definitions: ["声称"] },
  { word: "class", phonetic: "/klɑːs/", pos: "n.", definitions: ["班级"] },
  { word: "clean", phonetic: "/kliːn/", pos: "adj.", definitions: ["干净的"] },
  { word: "clear", phonetic: "/klɪə/", pos: "adj.", definitions: ["清楚的"] },
  { word: "client", phonetic: "/ˈklaɪənt/", pos: "n.", definitions: ["客户"] },
  { word: "climate", phonetic: "/ˈklaɪmət/", pos: "n.", definitions: ["气候"] },
  { word: "climb", phonetic: "/klaɪm/", pos: "v.", definitions: ["爬"] },
  { word: "clock", phonetic: "/klɒk/", pos: "n.", definitions: ["时钟"] },
  { word: "close", phonetic: "/kləʊz/", pos: "v.", definitions: ["关闭"] },
  { word: "clothes", phonetic: "/kləʊðz/", pos: "n.", definitions: ["衣服"] },
  { word: "cloud", phonetic: "/klaʊd/", pos: "n.", definitions: ["云"] },
  { word: "club", phonetic: "/klʌb/", pos: "n.", definitions: ["俱乐部"] },
  { word: "coach", phonetic: "/kəʊtʃ/", pos: "n.", definitions: ["教练"] },
  { word: "coast", phonetic: "/kəʊst/", pos: "n.", definitions: ["海岸"] },
  { word: "coat", phonetic: "/kəʊt/", pos: "n.", definitions: ["外套"] },
  { word: "code", phonetic: "/kəʊd/", pos: "n.", definitions: ["代码"] },
  { word: "coffee", phonetic: "/ˈkɒfi/", pos: "n.", definitions: ["咖啡"] },
  { word: "cold", phonetic: "/kəʊld/", pos: "adj.", definitions: ["冷的"] },
  { word: "collect", phonetic: "/kəˈlekt/", pos: "v.", definitions: ["收集"] },
  { word: "college", phonetic: "/ˈkɒlɪdʒ/", pos: "n.", definitions: ["大学"] },
  { word: "color", phonetic: "/ˈkʌlə/", pos: "n.", definitions: ["颜色"] },
  { word: "come", phonetic: "/kʌm/", pos: "v.", definitions: ["来"] },
  { word: "comfort", phonetic: "/ˈkʌmfət/", pos: "n.", definitions: ["舒适"] },
  { word: "command", phonetic: "/kəˈmɑːnd/", pos: "v.", definitions: ["命令"] },
  { word: "comment", phonetic: "/ˈkɒment/", pos: "n.", definitions: ["评论"] },
  { word: "common", phonetic: "/ˈkɒmən/", pos: "adj.", definitions: ["常见的"] },
  { word: "community", phonetic: "/kəˈmjuːnəti/", pos: "n.", definitions: ["社区"] },
  { word: "company", phonetic: "/ˈkʌmpəni/", pos: "n.", definitions: ["公司"] },
  { word: "compare", phonetic: "/kəmˈpeə/", pos: "v.", definitions: ["比较"] },
  { word: "compete", phonetic: "/kəmˈpiːt/", pos: "v.", definitions: ["竞争"] },
  { word: "complete", phonetic: "/kəmˈpliːt/", pos: "v.", definitions: ["完成"] },
  { word: "complex", phonetic: "/ˈkɒmpleks/", pos: "adj.", definitions: ["复杂的"] },
  { word: "computer", phonetic: "/kəmˈpjuːtə/", pos: "n.", definitions: ["计算机"] },
  { word: "concept", phonetic: "/ˈkɒnsept/", pos: "n.", definitions: ["概念"] },
  { word: "concern", phonetic: "/kənˈsɜːn/", pos: "v.", definitions: ["关心"] },
  { word: "condition", phonetic: "/kənˈdɪʃn/", pos: "n.", definitions: ["条件"] },
  { word: "conference", phonetic: "/ˈkɒnfərəns/", pos: "n.", definitions: ["会议"] },
  { word: "confirm", phonetic: "/kənˈfɜːm/", pos: "v.", definitions: ["确认"] },
  { word: "conflict", phonetic: "/ˈkɒnflɪkt/", pos: "n.", definitions: ["冲突"] },
  { word: "confuse", phonetic: "/kənˈfjuːz/", pos: "v.", definitions: ["使困惑"] },
  { word: "connect", phonetic: "/kəˈnekt/", pos: "v.", definitions: ["连接"] },
  { word: "consider", phonetic: "/kənˈsɪdə/", pos: "v.", definitions: ["考虑"] },
  { word: "consist", phonetic: "/kənˈsɪst/", pos: "v.", definitions: ["组成"] },
  { word: "constant", phonetic: "/ˈkɒnstənt/", pos: "adj.", definitions: ["持续的"] },
  { word: "contain", phonetic: "/kənˈteɪn/", pos: "v.", definitions: ["包含"] },
  { word: "content", phonetic: "/ˈkɒntent/", pos: "n.", definitions: ["内容"] },
  { word: "context", phonetic: "/ˈkɒntekst/", pos: "n.", definitions: ["上下文"] },
  { word: "continue", phonetic: "/kənˈtɪnjuː/", pos: "v.", definitions: ["继续"] },
  { word: "control", phonetic: "/kənˈtrəʊl/", pos: "v.", definitions: ["控制"] },
  { word: "convenient", phonetic: "/kənˈviːniənt/", pos: "adj.", definitions: ["方便的"] },
  { word: "conversation", phonetic: "/ˌkɒnvəˈseɪʃn/", pos: "n.", definitions: ["对话"] },
  { word: "cook", phonetic: "/kʊk/", pos: "v.", definitions: ["烹饪"] },
  { word: "cool", phonetic: "/kuːl/", pos: "adj.", definitions: ["凉爽的"] },
  { word: "copy", phonetic: "/ˈkɒpi/", pos: "v.", definitions: ["复制"] },
  { word: "correct", phonetic: "/kəˈrekt/", pos: "adj.", definitions: ["正确的"] },
  { word: "cost", phonetic: "/kɒst/", pos: "n.", definitions: ["费用"] },
  { word: "count", phonetic: "/kaʊnt/", pos: "v.", definitions: ["计数"] },
  { word: "country", phonetic: "/ˈkʌntri/", pos: "n.", definitions: ["国家"] },
  { word: "course", phonetic: "/kɔːs/", pos: "n.", definitions: ["课程"] },
  { word: "cover", phonetic: "/ˈkʌvə/", pos: "v.", definitions: ["覆盖"] },
  { word: "create", phonetic: "/kriˈeɪt/", pos: "v.", definitions: ["创造"] },
  { word: "credit", phonetic: "/ˈkredɪt/", pos: "n.", definitions: ["信用"] },
  { word: "crime", phonetic: "/kraɪm/", pos: "n.", definitions: ["犯罪"] },
  { word: "crisis", phonetic: "/ˈkraɪsɪs/", pos: "n.", definitions: ["危机"] },
  { word: "cross", phonetic: "/krɒs/", pos: "v.", definitions: ["穿过"] },
  { word: "crowd", phonetic: "/kraʊd/", pos: "n.", definitions: ["人群"] },
  { word: "culture", phonetic: "/ˈkʌltʃə/", pos: "n.", definitions: ["文化"] },
  { word: "current", phonetic: "/ˈkʌrənt/", pos: "adj.", definitions: ["当前的"] },
  { word: "custom", phonetic: "/ˈkʌstəm/", pos: "n.", definitions: ["习俗"] },
  { word: "customer", phonetic: "/ˈkʌstəmə/", pos: "n.", definitions: ["顾客"] },
  { word: "cut", phonetic: "/kʌt/", pos: "v.", definitions: ["切"] },
  { word: "daily", phonetic: "/ˈdeɪli/", pos: "adj.", definitions: ["每日的"] },
  { word: "damage", phonetic: "/ˈdæmɪdʒ/", pos: "n.", definitions: ["损害"] },
  { word: "dance", phonetic: "/dɑːns/", pos: "v.", definitions: ["跳舞"] },
  { word: "danger", phonetic: "/ˈdeɪndʒə/", pos: "n.", definitions: ["危险"] },
  { word: "dark", phonetic: "/dɑːk/", pos: "adj.", definitions: ["黑暗的"] },
  { word: "data", phonetic: "/ˈdeɪtə/", pos: "n.", definitions: ["数据"] },
  { word: "date", phonetic: "/deɪt/", pos: "n.", definitions: ["日期"] },
  { word: "day", phonetic: "/deɪ/", pos: "n.", definitions: ["天"] },
  { word: "dead", phonetic: "/ded/", pos: "adj.", definitions: ["死的"] },
  { word: "deal", phonetic: "/diːl/", pos: "v.", definitions: ["处理"] },
  { word: "death", phonetic: "/deθ/", pos: "n.", definitions: ["死亡"] },
  { word: "debate", phonetic: "/dɪˈbeɪt/", pos: "n.", definitions: ["辩论"] },
  { word: "decade", phonetic: "/ˈdekeɪd/", pos: "n.", definitions: ["十年"] },
  { word: "decide", phonetic: "/dɪˈsaɪd/", pos: "v.", definitions: ["决定"] },
  { word: "decision", phonetic: "/dɪˈsɪʒn/", pos: "n.", definitions: ["决定"] },
  { word: "deep", phonetic: "/diːp/", pos: "adj.", definitions: ["深的"] },
  { word: "defend", phonetic: "/dɪˈfend/", pos: "v.", definitions: ["防御"] },
  { word: "define", phonetic: "/dɪˈfaɪn/", pos: "v.", definitions: ["定义"] },
  { word: "degree", phonetic: "/dɪˈɡriː/", pos: "n.", definitions: ["程度"] },
  { word: "delay", phonetic: "/dɪˈleɪ/", pos: "v.", definitions: ["延迟"] },
  { word: "deliver", phonetic: "/dɪˈlɪvə/", pos: "v.", definitions: ["递送"] },
  { word: "demand", phonetic: "/dɪˈmɑːnd/", pos: "n.", definitions: ["需求"] },
  { word: "depend", phonetic: "/dɪˈpend/", pos: "v.", definitions: ["依赖"] },
  { word: "describe", phonetic: "/dɪˈskraɪb/", pos: "v.", definitions: ["描述"] },
  { word: "design", phonetic: "/dɪˈzaɪn/", pos: "v.", definitions: ["设计"] },
  { word: "desk", phonetic: "/desk/", pos: "n.", definitions: ["书桌"] },
  { word: "detail", phonetic: "/ˈdiːteɪl/", pos: "n.", definitions: ["细节"] },
  { word: "determine", phonetic: "/dɪˈtɜːmɪn/", pos: "v.", definitions: ["决定"] },
  { word: "develop", phonetic: "/dɪˈveləp/", pos: "v.", definitions: ["发展"] },
  { word: "device", phonetic: "/dɪˈvaɪs/", pos: "n.", definitions: ["设备"] },
  { word: "die", phonetic: "/daɪ/", pos: "v.", definitions: ["死亡"] },
  { word: "difference", phonetic: "/ˈdɪfrəns/", pos: "n.", definitions: ["差异"] },
  { word: "different", phonetic: "/ˈdɪfrənt/", pos: "adj.", definitions: ["不同的"] },
  { word: "difficult", phonetic: "/ˈdɪfɪkəlt/", pos: "adj.", definitions: ["困难的"] },
  { word: "direct", phonetic: "/dəˈrekt/", pos: "adj.", definitions: ["直接的"] },
  { word: "direction", phonetic: "/dəˈrekʃn/", pos: "n.", definitions: ["方向"] },
  { word: "director", phonetic: "/dəˈrektə/", pos: "n.", definitions: ["导演"] },
  { word: "disappear", phonetic: "/ˌdɪsəˈpɪə/", pos: "v.", definitions: ["消失"] },
  { word: "discover", phonetic: "/dɪˈskʌvə/", pos: "v.", definitions: ["发现"] },
  { word: "discuss", phonetic: "/dɪˈskʌs/", pos: "v.", definitions: ["讨论"] },
  { word: "disease", phonetic: "/dɪˈziːz/", pos: "n.", definitions: ["疾病"] },
  { word: "distance", phonetic: "/ˈdɪstəns/", pos: "n.", definitions: ["距离"] },
  { word: "divide", phonetic: "/dɪˈvaɪd/", pos: "v.", definitions: ["划分"] },
  { word: "doctor", phonetic: "/ˈdɒktə/", pos: "n.", definitions: ["医生"] },
  { word: "document", phonetic: "/ˈdɒkjumənt/", pos: "n.", definitions: ["文档"] },
  { word: "dollar", phonetic: "/ˈdɒlə/", pos: "n.", definitions: ["美元"] },
  { word: "door", phonetic: "/dɔː/", pos: "n.", definitions: ["门"] },
  { word: "double", phonetic: "/ˈdʌbl/", pos: "adj.", definitions: ["双倍的"] },
  { word: "doubt", phonetic: "/daʊt/", pos: "n.", definitions: ["怀疑"] },
  { word: "down", phonetic: "/daʊn/", pos: "adv.", definitions: ["向下"] },
  { word: "draw", phonetic: "/drɔː/", pos: "v.", definitions: ["画"] },
  { word: "dream", phonetic: "/driːm/", pos: "n.", definitions: ["梦想"] },
  { word: "dress", phonetic: "/dres/", pos: "v.", definitions: ["穿衣"] },
  { word: "drink", phonetic: "/drɪŋk/", pos: "v.", definitions: ["喝"] },
  { word: "drive", phonetic: "/draɪv/", pos: "v.", definitions: ["驾驶"] },
  { word: "drop", phonetic: "/drɒp/", pos: "v.", definitions: ["掉落"] },
  { word: "drug", phonetic: "/drʌɡ/", pos: "n.", definitions: ["药物"] },
  { word: "during", phonetic: "/ˈdjʊərɪŋ/", pos: "prep.", definitions: ["在...期间"] },
  { word: "duty", phonetic: "/ˈdjuːti/", pos: "n.", definitions: ["责任"] },
  { word: "each", phonetic: "/iːtʃ/", pos: "adj.", definitions: ["每个"] },
  { word: "early", phonetic: "/ˈɜːli/", pos: "adv.", definitions: ["早"] },
  { word: "earn", phonetic: "/ɜːn/", pos: "v.", definitions: ["赚取"] },
  { word: "earth", phonetic: "/ɜːθ/", pos: "n.", definitions: ["地球"] },
  { word: "easy", phonetic: "/ˈiːzi/", pos: "adj.", definitions: ["容易的"] },
  { word: "eat", phonetic: "/iːt/", pos: "v.", definitions: ["吃"] },
  { word: "economy", phonetic: "/ɪˈkɒnəmi/", pos: "n.", definitions: ["经济"] },
  { word: "edge", phonetic: "/edʒ/", pos: "n.", definitions: ["边缘"] },
  { word: "education", phonetic: "/ˌedʒuˈkeɪʃn/", pos: "n.", definitions: ["教育"] },
  { word: "effect", phonetic: "/ɪˈfekt/", pos: "n.", definitions: ["效果"] },
  { word: "effort", phonetic: "/ˈefət/", pos: "n.", definitions: ["努力"] },
  { word: "election", phonetic: "/ɪˈlekʃn/", pos: "n.", definitions: ["选举"] },
  { word: "electric", phonetic: "/ɪˈlektrɪk/", pos: "adj.", definitions: ["电的"] },
  { word: "element", phonetic: "/ˈelɪmənt/", pos: "n.", definitions: ["元素"] },
  { word: "else", phonetic: "/els/", pos: "adv.", definitions: ["其他的"] },
  { word: "email", phonetic: "/ˈiːmeɪl/", pos: "n.", definitions: ["电子邮件"] },
  { word: "emotion", phonetic: "/ɪˈməʊʃn/", pos: "n.", definitions: ["情感"] },
  { word: "employ", phonetic: "/ɪmˈplɔɪ/", pos: "v.", definitions: ["雇佣"] },
  { word: "empty", phonetic: "/ˈempti/", pos: "adj.", definitions: ["空的"] },
  { word: "enable", phonetic: "/ɪˈneɪbl/", pos: "v.", definitions: ["使能够"] },
  { word: "end", phonetic: "/end/", pos: "n.", definitions: ["结束"] },
  { word: "enemy", phonetic: "/ˈenəmi/", pos: "n.", definitions: ["敌人"] },
  { word: "energy", phonetic: "/ˈenədʒi/", pos: "n.", definitions: ["能量"] },
  { word: "engine", phonetic: "/ˈendʒɪn/", pos: "n.", definitions: ["引擎"] },
  { word: "engineer", phonetic: "/ˌendʒɪˈnɪə/", pos: "n.", definitions: ["工程师"] },
  { word: "enjoy", phonetic: "/ɪnˈdʒɔɪ/", pos: "v.", definitions: ["享受"] },
  { word: "enough", phonetic: "/ɪˈnʌf/", pos: "adj.", definitions: ["足够的"] },
  { word: "enter", phonetic: "/ˈentə/", pos: "v.", definitions: ["进入"] },
  { word: "entire", phonetic: "/ɪnˈtaɪə/", pos: "adj.", definitions: ["整个的"] },
  { word: "environment", phonetic: "/ɪnˈvaɪrənmənt/", pos: "n.", definitions: ["环境"] },
  { word: "equal", phonetic: "/ˈiːkwəl/", pos: "adj.", definitions: ["平等的"] },
  { word: "error", phonetic: "/ˈerə/", pos: "n.", definitions: ["错误"] },
  { word: "escape", phonetic: "/ɪˈskeɪp/", pos: "v.", definitions: ["逃跑"] },
  { word: "especially", phonetic: "/ɪˈspeʃəli/", pos: "adv.", definitions: ["特别地"] },
  { word: "establish", phonetic: "/ɪˈstæblɪʃ/", pos: "v.", definitions: ["建立"] },
  { word: "estimate", phonetic: "/ˈestɪmət/", pos: "v.", definitions: ["估计"] },
  { word: "evaluate", phonetic: "/ɪˈvæljueɪt/", pos: "v.", definitions: ["评估"] },
  { word: "even", phonetic: "/ˈiːvn/", pos: "adv.", definitions: ["甚至"] },
  { word: "event", phonetic: "/ɪˈvent/", pos: "n.", definitions: ["事件"] },
  { word: "ever", phonetic: "/ˈevə/", pos: "adv.", definitions: ["曾经"] },
  { word: "every", phonetic: "/ˈevri/", pos: "adj.", definitions: ["每个"] },
  { word: "evidence", phonetic: "/ˈevɪdəns/", pos: "n.", definitions: ["证据"] },
  { word: "exact", phonetic: "/ɪɡˈzækt/", pos: "adj.", definitions: ["精确的"] },
  { word: "examine", phonetic: "/ɪɡˈzæmɪn/", pos: "v.", definitions: ["检查"] },
  { word: "example", phonetic: "/ɪɡˈzɑːmpl/", pos: "n.", definitions: ["例子"] },
  { word: "excellent", phonetic: "/ˈeksələnt/", pos: "adj.", definitions: ["优秀的"] },
  { word: "except", phonetic: "/ɪkˈsept/", pos: "prep.", definitions: ["除了"] },
  { word: "exchange", phonetic: "/ɪksˈtʃeɪndʒ/", pos: "v.", definitions: ["交换"] },
  { word: "exist", phonetic: "/ɪɡˈzɪst/", pos: "v.", definitions: ["存在"] },
  { word: "expect", phonetic: "/ɪkˈspekt/", pos: "v.", definitions: ["期望"] },
  { word: "expensive", phonetic: "/ɪkˈspensɪv/", pos: "adj.", definitions: ["昂贵的"] },
  { word: "experience", phonetic: "/ɪkˈspɪəriəns/", pos: "n.", definitions: ["经验"] },
  { word: "experiment", phonetic: "/ɪkˈsperɪmənt/", pos: "n.", definitions: ["实验"] },
  { word: "expert", phonetic: "/ˈekspɜːt/", pos: "n.", definitions: ["专家"] },
  { word: "explain", phonetic: "/ɪkˈspleɪn/", pos: "v.", definitions: ["解释"] },
  { word: "explore", phonetic: "/ɪkˈsplɔː/", pos: "v.", definitions: ["探索"] },
  { word: "express", phonetic: "/ɪkˈspres/", pos: "v.", definitions: ["表达"] },
  { word: "extra", phonetic: "/ˈekstrə/", pos: "adj.", definitions: ["额外的"] },
  { word: "face", phonetic: "/feɪs/", pos: "n.", definitions: ["脸"] },
  { word: "fact", phonetic: "/fækt/", pos: "n.", definitions: ["事实"] },
  { word: "factor", phonetic: "/ˈfæktə/", pos: "n.", definitions: ["因素"] },
  { word: "factory", phonetic: "/ˈfæktəri/", pos: "n.", definitions: ["工厂"] },
  { word: "fail", phonetic: "/feɪl/", pos: "v.", definitions: ["失败"] },
  { word: "fair", phonetic: "/feə/", pos: "adj.", definitions: ["公平的"] },
  { word: "fall", phonetic: "/fɔːl/", pos: "v.", definitions: ["落下"] },
  { word: "false", phonetic: "/fɔːls/", pos: "adj.", definitions: ["错误的"] },
  { word: "family", phonetic: "/ˈfæməli/", pos: "n.", definitions: ["家庭"] },
  { word: "famous", phonetic: "/ˈfeɪməs/", pos: "adj.", definitions: ["著名的"] },
  { word: "far", phonetic: "/fɑː/", pos: "adv.", definitions: ["远的"] },
  { word: "farm", phonetic: "/fɑːm/", pos: "n.", definitions: ["农场"] },
  { word: "fast", phonetic: "/fɑːst/", pos: "adj.", definitions: ["快的"] },
  { word: "father", phonetic: "/ˈfɑːðə/", pos: "n.", definitions: ["父亲"] },
  { word: "fault", phonetic: "/fɔːlt/", pos: "n.", definitions: ["错误"] },
  { word: "favorite", phonetic: "/ˈfeɪvərɪt/", pos: "adj.", definitions: ["最喜欢的"] },
  { word: "fear", phonetic: "/fɪə/", pos: "n.", definitions: ["恐惧"] },
  { word: "feature", phonetic: "/ˈfiːtʃə/", pos: "n.", definitions: ["特征"] },
  { word: "feel", phonetic: "/fiːl/", pos: "v.", definitions: ["感觉"] },
  { word: "field", phonetic: "/fiːld/", pos: "n.", definitions: ["领域"] },
  { word: "fight", phonetic: "/faɪt/", pos: "v.", definitions: ["战斗"] },
  { word: "figure", phonetic: "/ˈfɪɡə/", pos: "n.", definitions: ["数字"] },
  { word: "file", phonetic: "/faɪl/", pos: "n.", definitions: ["文件"] },
  { word: "fill", phonetic: "/fɪl/", pos: "v.", definitions: ["填充"] },
  { word: "film", phonetic: "/fɪlm/", pos: "n.", definitions: ["电影"] },
  { word: "final", phonetic: "/ˈfaɪnl/", pos: "adj.", definitions: ["最终的"] },
  { word: "find", phonetic: "/faɪnd/", pos: "v.", definitions: ["找到"] },
  { word: "finger", phonetic: "/ˈfɪŋɡə/", pos: "n.", definitions: ["手指"] },
  { word: "finish", phonetic: "/ˈfɪnɪʃ/", pos: "v.", definitions: ["完成"] },
  { word: "fire", phonetic: "/ˈfaɪə/", pos: "n.", definitions: ["火"] },
  { word: "first", phonetic: "/fɜːst/", pos: "adj.", definitions: ["第一"] },
  { word: "fish", phonetic: "/fɪʃ/", pos: "n.", definitions: ["鱼"] },
  { word: "fit", phonetic: "/fɪt/", pos: "v.", definitions: ["适合"] },
  { word: "fix", phonetic: "/fɪks/", pos: "v.", definitions: ["修理"] },
  { word: "flight", phonetic: "/flaɪt/", pos: "n.", definitions: ["航班"] },
  { word: "floor", phonetic: "/flɔː/", pos: "n.", definitions: ["地板"] },
  { word: "flower", phonetic: "/ˈflaʊə/", pos: "n.", definitions: ["花"] },
  { word: "fly", phonetic: "/flaɪ/", pos: "v.", definitions: ["飞"] },
  { word: "focus", phonetic: "/ˈfəʊkəs/", pos: "v.", definitions: ["聚焦"] },
  { word: "follow", phonetic: "/ˈfɒləʊ/", pos: "v.", definitions: ["跟随"] },
  { word: "food", phonetic: "/fuːd/", pos: "n.", definitions: ["食物"] },
  { word: "force", phonetic: "/fɔːs/", pos: "n.", definitions: ["力量"] },
  { word: "foreign", phonetic: "/ˈfɒrən/", pos: "adj.", definitions: ["外国的"] },
  { word: "forest", phonetic: "/ˈfɒrɪst/", pos: "n.", definitions: ["森林"] },
  { word: "forget", phonetic: "/fəˈɡet/", pos: "v.", definitions: ["忘记"] },
  { word: "form", phonetic: "/fɔːm/", pos: "n.", definitions: ["形式"] },
  { word: "former", phonetic: "/ˈfɔːmə/", pos: "adj.", definitions: ["前任的"] },
  { word: "forward", phonetic: "/ˈfɔːwəd/", pos: "adv.", definitions: ["向前"] },
  { word: "foundation", phonetic: "/faʊnˈdeɪʃn/", pos: "n.", definitions: ["基础"] },
  { word: "free", phonetic: "/friː/", pos: "adj.", definitions: ["自由的"] },
  { word: "fresh", phonetic: "/freʃ/", pos: "adj.", definitions: ["新鲜的"] },
  { word: "friend", phonetic: "/frend/", pos: "n.", definitions: ["朋友"] },
  { word: "front", phonetic: "/frʌnt/", pos: "n.", definitions: ["前面"] },
  { word: "fruit", phonetic: "/fruːt/", pos: "n.", definitions: ["水果"] },
  { word: "full", phonetic: "/fʊl/", pos: "adj.", definitions: ["满的"] },
  { word: "fun", phonetic: "/fʌn/", pos: "n.", definitions: ["乐趣"] },
  { word: "future", phonetic: "/ˈfjuːtʃə/", pos: "n.", definitions: ["未来"] },
];
// 共 454 词条
